angular.module("imagenet")
    .factory('TokenLibrary', ["$window", "$injector", "API_URL", "$q",function ($window, $injector, API_URL, $q) {
        'use strict';
        var storage = $window.localStorage;
        var sessionStorage = $window.sessionStorage;
        var refreshKey = 'refresh-token';
        var libKey = 'token-lib';
        var lib = {};
        var currentPromise;

        return {
            setRefreshToken: setRefreshToken,
            setLib: setLib,
            getRefreshToken: getRefreshToken,
            getLib: getLib,
            clear: clear
        };

        function setRefreshToken(data) {
            storage.setItem(refreshKey, data.refreshToken);
        }

        function getRefreshToken() {
            return storage.getItem(refreshKey);
        }

        function setLib(data) {
            if (data) {
                lib = data;
                sessionStorage.setItem(libKey, $window.btoa(JSON.stringify(data)));
            }
        }

        function getLib(prop) {
            var defer = $q.defer();
            if (!lib || angular.equals(lib, {})) {
                if (sessionStorage.getItem(libKey)) lib = JSON.parse($window.atob(sessionStorage.getItem(libKey)));
            }
            console.log("getlib:", lib);
            if (lib && !angular.equals(lib, {}) && new Date(lib.expiration) > new Date()) {
                console.log("lib var expiration geçmemiş");
                if (prop) defer.resolve(lib[prop]);
                else defer.resolve(lib);
            } else {
                if (!lib || angular.equals(lib, {})) console.log("lib yok");
                console.log("expiration geçmiş", lib.expiration);
                if (currentPromise) {
                    currentPromise.then(function (response) {
                        if (prop) defer.resolve(lib[prop]);
                        else defer.resolve(lib);
                    });
                } else {
                    var $http = $injector.get('$http');
                    currentPromise = $http.get(API_URL + '/api/auth/token').then(function (response) {
                        setLib(response.data);
                        currentPromise = null;
                        if (prop) defer.resolve(lib[prop]);
                        else defer.resolve(lib);
                    });
                }

            }

            return defer.promise;
        }

        function clear() {
            storage.removeItem(refreshKey);
            sessionStorage.removeItem(libKey);
            lib = {};
        }
    }]);
